import { render, staticRenderFns } from "./file-pres-add.vue?vue&type=template&id=329a62fe"
import script from "./file-pres-add.vue?vue&type=script&lang=js"
export * from "./file-pres-add.vue?vue&type=script&lang=js"
import style0 from "./file-pres-add.vue?vue&type=style&index=0&id=329a62fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports